<form novalidate #propertySaleAttributeSectionForm="ngForm">
    <div class="property-sale-attribute-section__viewInstructions">
        <tg-input-container
            class="property-sale-attribute-section__viewInstructions-input"
            label="Viewing instructions"
            showRemainingCharacters="false"
        >
            <textarea
                tgTextInput
                ngModel
                name="viewInstructions"
                rows="3"
                [validation]="
                    validation.propertyDescription.viewingInstructions | toValidator
                "
                placeholder="e.g. By appointment, open home date/time, etc."
                (blur)="publish()"
                [(ngModel)]="draftData.propertyDescription.viewingInstructions"
            ></textarea>
        </tg-input-container>
    </div>
</form>